export const resolveRelations = ['featuredBlogs.blogs', 'blog.categories', 'categories.blog'];

export const resolveRelationsQueryParams = resolveRelations.join(',');
